import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import { UserService } from '../../../core/services/core.user.service';
import { marker } from '../../../core/services/ngx-translate-extract-marker';

@Injectable()
export class WikiBrowseService {
    constructor(
        private gfTranslateService: GfTranslateService,
        private userService: UserService
    ) {}

    getSortFields() {
        return {
            'id': this.gfTranslateService.translate('Id'),
            'pagename': this.gfTranslateService.translate('Page Name'),
            'author': this.gfTranslateService.translate('Author'),
            'latestVersion': this.gfTranslateService.translate('Current Version'),
            'createdDate': this.gfTranslateService.translate('Created Date'),
            'updatedDate': this.gfTranslateService.translate('Last Updated')
        };
    }

    getAuthorElements(members: any[]): { id: any; label: string; unixName?: string }[] {
        return [{ id: '', label: this.gfTranslateService.translate(marker("Any")) }]
            .concat(_.map(members, (member) => ({
                id: member.id,
                label: this.userService.fullName(member),
                unixName: member.unixName
            })));
    }

    getBaseFilters(members: any[] = []) {
        var t = (s) => this.gfTranslateService.translate(s);
        var authorElements = this.getAuthorElements(members);

        return [
            { alias: "pagename", fieldName: t(marker("Page Name")), value: "", fieldType: 4, isExtraField: false },
            { alias: "content", fieldName: t(marker("Text Search")), value: "", fieldType: 4, isExtraField: false },
            {
                alias: "author", fieldName: t(marker("Author")),
                value: authorElements[0], fieldType: 1, isExtraField: false,
                fieldElements: authorElements
            },
            {
                alias: "authorAnyVersion", fieldName: t(marker("Version Match")),
                value: { id: '', label: t(marker("Latest Version Only")) }, fieldType: 1, isExtraField: false,
                fieldElements: [
                    { id: '', label: t(marker("Latest Version Only")) },
                    { id: '1', label: t(marker("Any Version")) }
                ]
            },
            { alias: "createdDateFrom", fieldName: t(marker("Created From")), value: "", fieldType: 9, isExtraField: false },
            { alias: "createdDateTo", fieldName: t(marker("Created To")), value: "", fieldType: 9, isExtraField: false },
            { alias: "updatedDateFrom", fieldName: t(marker("Updated From")), value: "", fieldType: 9, isExtraField: false },
            { alias: "updatedDateTo", fieldName: t(marker("Updated To")), value: "", fieldType: 9, isExtraField: false }
        ];
    }
}
